/**
 * eventPosters — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {PORTRAIT, tagline, chips, type ToilePack} from './data'

export const eventPostersPack: ToilePack = {
    slug: 'event-posters',
    category: 'poster',
    name: 'Event posters',
    tagline: tagline('posters', 'events', 'styles'),
    chips: chips('events', 'styles'),
    ratio: PORTRAIT,
    readings: [
        {key: 'jazz', label: 'Blue Room Sessions', subject: 'a jazz night, a double bass and trumpet under one hanging lamp'},
        {key: 'market', label: 'Riverside Market', subject: 'a farmers market, vegetable crates, a bicycle basket and bunting'},
        {key: 'exhibition', label: 'Soft Geometry', subject: 'an art exhibition, overlapping translucent circles and arcs'},
    ],
    styles: [
        {key: 'swiss', label: 'Swiss minimal', style: 'Swiss minimal, a strict grid', palette: 'one accent on off-white', framing: 'vertical poster, wide empty space'},
        {key: 'letterpress', label: 'Letterpress', style: 'vintage letterpress, wood-type lettering', palette: 'two inks on cream paper', framing: 'vertical poster, visible impression'},
        {key: 'illustration', label: 'Bold illustration', style: 'bold illustration, heavy flat shapes', palette: 'four-color palette', framing: 'vertical poster, type in the artwork'},
    ],
    directions: ['a film festival instead', 'in red and black', 'busier, more to read'],
}
